module.exports = __webpack_public_path__ + "static/media/pic-svg-17.4d214f00.svg";